// actions.js
import * as actionTypes from "./actionsTypes";

export const setValuePdp = (value) => ({
  type: actionTypes.SET_VALUE_Pdp,
  payload: value,
});

export const setTypePdp = (type) => ({
  type: actionTypes.SET_TYPE_Pdp,
  payload: type,
});
export const setActifPdp = (actif) => ({
  type: actionTypes.SET_ACTIF_Pdp,
  payload: actif,
});

export const setCurrentPagePdp = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_Pdp,
  payload: page,
});

export const setOrderPdp = (order) => ({
  type: actionTypes.SET_ORDER_Pdp,
  payload: order,
});

export const setSortFieldPdp = (field) => ({
  type: actionTypes.SET_SORT_FIELD_Pdp,
  payload: field,
});
